var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_52666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.666 7.33301C11.7727 7.33301 12.6593 6.43967 12.6593 5.33301C12.6593 4.22634 11.7727 3.33301 10.666 3.33301C9.55935 3.33301 8.66602 4.22634 8.66602 5.33301C8.66602 6.43967 9.55935 7.33301 10.666 7.33301ZM5.33268 7.33301C6.43935 7.33301 7.32602 6.43967 7.32602 5.33301C7.32602 4.22634 6.43935 3.33301 5.33268 3.33301C4.22602 3.33301 3.33268 4.22634 3.33268 5.33301C3.33268 6.43967 4.22602 7.33301 5.33268 7.33301ZM5.33268 8.66634C3.77935 8.66634 0.666016 9.44634 0.666016 10.9997V11.9997C0.666016 12.3663 0.966016 12.6663 1.33268 12.6663H9.33268C9.69935 12.6663 9.99935 12.3663 9.99935 11.9997V10.9997C9.99935 9.44634 6.88602 8.66634 5.33268 8.66634ZM10.666 8.66634C10.4727 8.66634 10.2527 8.67967 10.0193 8.69967C10.0327 8.70634 10.0393 8.71967 10.046 8.72634C10.806 9.27967 11.3327 10.0197 11.3327 10.9997V11.9997C11.3327 12.233 11.286 12.4597 11.2127 12.6663H14.666C15.0327 12.6663 15.3327 12.3663 15.3327 11.9997V10.9997C15.3327 9.44634 12.2193 8.66634 10.666 8.66634Z",
    fill: "#265183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_52666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/user-management.d3f0f37f3de296bcb12ac4f559179aeb.svg";
export { ForwardRef as ReactComponent };